import withSharedStyles from "../theme/Shared.style";

const withCustomStyles = withSharedStyles(theme => ({
  tileItem: {
    padding: "0 10px 32px",
    [theme.media.phone]: { padding: "0 6px 24px" },
    // MUI Grid stops at lg={2} (6 per row); wide screens get 7, then 8.
    // !important beats the Grid's own lg flex-basis/max-width rules.
    [theme.media.wide]: {
      flexBasis: `${100 / 7}% !important`,
      maxWidth: `${100 / 7}% !important`
    },
    [theme.media.xwide]: {
      flexBasis: "12.5% !important",
      maxWidth: "12.5% !important"
    }
  },
  card: {
    display: "flex",
    flexDirection: "column",
    gap: 6
  },
  tile: {
    aspectRatio: "1 / 1",
    height: "auto !important",
    minHeight: 140,
    borderRadius: `${theme.tokens.radius.tile}px !important`,
    marginBottom: 6
  }
}));

export default withCustomStyles;
